const StatusTypes = {
  loginPending: 'loginPending',
  loginSuccess: 'loginSuccess',
  loginFail: 'loginFail',
  registerPending: 'registerPending',
  registerSuccess: 'registerSuccess',
  registerFail: 'registerFail',
  updateUserPending: 'updateUserPending',
  updateUserSuccess: 'updateUserSuccess',
  updateUserFail: 'updateUserFail',
  uploadUserImgPending: 'uploadUserImgPending',
  uploadUserImgSuccess: 'uploadUserImgSuccess',
  uploadUserImgFail: 'uploadUserImgFail',
  getWorkoutsPending: 'getWorkoutsPending',
  getWorkoutsSuccess: 'getWorkoutsSuccess',
  getWorkoutsFail: 'getWorkoutsFail',
  getWorkoutPending: 'getWorkoutPending',
  getWorkoutSuccess: 'getWorkoutSuccess',
  getWorkoutFail: 'getWorkoutFail',
  getExercisesPending: 'getExercisesPending',
  getExercisesSuccess: 'getExercisesSuccess',
  getExercisesFail: 'getExercisesFail',
};

export default StatusTypes;
